import React, { useState, Component, Fragment } from "react";
import Switch from "@material-ui/core/Switch";
import { Navigationmenu } from "../components";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReactSession from "../reactclient.js";
import { withRouter } from "react-router-dom";
import circulargridimage from "../gallery/gridloader.gif";

import DatePicker from "react-datepicker";
import moment, { max } from "moment";
// import 'react-datepicker/dist/react-datepicker.css';
import Footer from "../components/Footer";
import {
  Box,
  Button,
  Typography,
  Grid,
  Divider,
  MuiEditableLabel,
  TextField,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Popover,
  Dialog,
  Tabs,
  Tab,
  DialogActions,
  withStyles,
  TableFooter,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  SearchOutlined,
  ArrowDropDown,
  Publish,
  NoteAdd,
  ArrowDropUp,
  InsertDriveFileOutlined,
  AlternateEmail,
  AlternateEmailTwoTone,
} from "@material-ui/icons";
import {
  ALTERNATEROW_BACKGROUND_COLOR,
  BLUE_COLOR,
  LIGHTGRAY_COLOR,
  MODIFIEDBLACK,
  PINK_COLOR,
  PROTECT_GREEN,
  RED_COLOR,
  VIBRANT_GREEN,
} from "../constants";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from "render-if";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { findAllByPlaceholderText } from "@testing-library/react";
import { fnPostapiResponse, fnGETapiResponse, Fnencryption } from "../APICall";

const StyledTabs = withStyles(
  {
    indicator: {
      display: "flex",
      backgroundColor: "white",
      height: 3,
    },
  },
  { index: 1 }
)((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles(
  (theme) => (
    {
      root: {
        textTransform: "none",
        color: "white",
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        "&:focus": {
          opacity: 1,
        },
      },
    },
    { index: 1 }
  )
)((props) => <Tab disableRipple {...props} />);

export default class CDDCRM extends Component {
  state = {
    tablebuffer: [],
    pages: 0,
    current: 1,
    records: 0,
    pageSize: 10,
    showPager: false,
    SearchButtonDisable: false,
    SOURCE: "",
    FNAME: "",
    SNAME: "",
    pagesObj: [],
    OWNERTYPE: [],
    PRODUCT: [],
    PREMIUM: [],
    NATIONALITY: [],
    COUNTRY: [],
    TSECTOR: [],
    INTRO: [],
    BENEF: [],
    SRCFUND: [],
    PEP: [],
    AML: [],
    COMPLEX: [],
    CINCORP: [],
    CompanyType: [],
    ClientType: [],
    Occupation: [],
    SelectedOwnerType: "",
    SelectedProductType: "",
    SelectedPREMIUMType: "",
    SelectedNATIONALITYType: "",
    SelectedCOUNTRYYType: "",
    SelectedTSECTORType: "",
    SelectedTSECTORText: "",
    SelectedINTROType: "",
    SelectedBENEFType: "",
    SelectedSRCFUNDType: "",
    SelectedPEPType: "",
    SelectedAMl: "",
    SelectedCOMPLEXType: "",
    SelectedCINCORPType: "",
    SelectedOccupationType: "",
    SelectedOwnerTypeSCORE: 0,
    SelectedProductTypeSCORE: 0,
    SelectedPREMIUMTypeSCORE: 0,
    SelectedNATIONALITYTypeSCORE: 0,
    SelectedCOUNTRYTypeSCORE: 0,
    SelectedTSECTORTypeSCORE: 0,
    SelectedINTROTypeSCORE: 0,
    SelectedBENEFTypeSCORE: 0,
    SelectedSRCFUNDTypeSCORE: 0,
    SelectedPEPTypeSCORE: 0,
    SelectedAMLSCORE: 0,
    SelectedCOMPLEXTypeSCORE: 0,
    SelectedCINCORPTypeSCORE: 0,
    SelectedOccupationTypeScore: 0,
    SelectedCompany: "",
    SelectedClientName: "",
    SelectedClientType: "",
    SelectedNICType: "",
    SelectedNicLabel: "",
    selectedDropCountry: "",
    Dropcountry: [],
    NICdrop: [],
    nivvaliderror: "",
    SelectedBRN: "",
    SelectedNic: "",
    selectedProductLabel: "Product Type :",
    selectedPremiumLabel: "Amount of Premium :",
    displaycountry: "none",
    selectedbeneficiaryLabel: "",
    TotalRiskCount: 0,
    selectedDate: "",
    riskProfile: "",
    showBeneficiaryComponent: false,
    showNewCDDC: false,
    validateAlloptions: false,
    SavebuttonDisable: false,
    searchbuttonbackcolor: BLUE_COLOR,
    clearbuttonbackcolor: BLUE_COLOR,
    isadmin: false,
    isadminSwitch: false,
    ShowOccupation: true,
    diableRadio: true,
    BeneFitPayble: false,
    ChckOnboarding: true,
    disableSelectedINTROType: false,
    disableSelectedpaymentType: false,
    disableBenef: false,
    Nainpayment: true,
    NANSourceOfFund: true,
    NANSourceOfIntroduction: true,
    NANBenef: true,
    clearresult: true,
  };
  handleChange = (event) => {
    this.setState({ isadmin: event.target.checked });
  };
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleLeavePage);
  }

  handleLeavePage(e) {
    const confirmationMessage = "My message";
    e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
    return confirmationMessage; // Gecko, WebKit, Chrome <34
  }

  fntocheckMandatory(e) {
    if (e == "SEARCHCRP") {
      if (this.state.SelectedCompany == null) {
        alert("Please enter the Company Name");
        this.state.ismandatory = false;
      } else if (
        (this.state.SelectedClientName == null ||
          this.state.SelectedClientName == "") &&
        this.state.SelectedNic == ""
      ) {
        alert("Please enter either Client Number OR NIC");
        this.state.ismandatory = false;
      } else if (
        this.state.SelectedClientName != null &&
        this.state.SelectedClientName != "" &&
        this.state.SelectedNic != ""
      ) {
        alert("Please note that you cannot enter both Client Number and NIC.");
        this.state.ismandatory = false;
      } else {
        this.state.ismandatory = true;
      }
    }
  }

  RefinitiveresponseandCRP(e) {
    this.fntocheckMandatory(e);

    if (this.state.ismandatory) {
      if (e == "SEARCHCRP") {
        this.state.selectedOption = true;
        this.refinitsearchfun(e);
      } else {
        if (
          this.state.selectedPassDROP == "NIC" &&
          !this.state.isforeignSwitchChecked
        ) {
          this.state.isloading = true;
          this.Nicchecking(this.state.caseid.toUpperCase().trim());
        } else {
          this.state.selectedOption = false;
          this.refinitsearchfun(e);
        }
      }
    }
  }

  fnsetNICTypeRefinitSearch(clnttype) {
    var data = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "GETNICBRN",
      MAPIPORT: process.env.REACT_APP_MPORT,
      body: clnttype,
    };
    fnGETapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "GetApiMiddleWare",
      data,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response) => {
        this.setState({ NICdrop: response.data["nicbrnval"][0] });
        // console.log("ddd",this.state.NICdrop)
        this.FntocheckpassDrop(this.state.SelectedNICType);
      })
      .catch((e) => console.log(e));
  }

  refinitsearchfun(e) {
    this.setState({ alldata: [] });
    this.state.pagesObj = [];
    this.state.newOBJ = [];
    var clientIdValue = this.state.SelectedClientName;
    var NICValue = this.state.SelectedNic;
    var NICandBRNValue = "";
    if (
      this.state.SelectedNICType == "PAS" &&
      this.state.selectedDropCountry != ""
    ) {
      NICandBRNValue +=
        "PAS-" +
        this.state.SelectedNic.trim() +
        "-" +
        this.state.selectedDropCountry;
    } else if (
      this.state.SelectedNICType == "PAS" &&
      this.state.selectedDropCountry == ""
    ) {
      NICandBRNValue += "PAS-" + this.state.SelectedNic.trim();
    } else {
      NICandBRNValue +=
        this.state.SelectedNICType + "-" + this.state.SelectedNic.trim();
    }

    if (clientIdValue == "" || clientIdValue == null) {
      var data = {
        MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
        MAPINAME: "GETCRPDETAILSNIC",
        MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
        body: {
          NIC: NICandBRNValue || "",
          companyId: this.state.SelectedCompany || "",
          ClientNo: this.state.SelectedClientName || "",
        },
      };
      this.state.isloading = true;
      fnPostapiResponse(
        process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
        "PostApiMiddleWare",
        data,
        process.env.REACT_APP_PORT_MIDDLEWARE
      )
        .then((response) => {
          var data2 = response.data[0][0];
          console.log(data2)
          if (data2 == undefined) {
            alert("No data available for this search");
          } else {
            var ownerType = data2.OWNERTYPE_CD;
            var countryIncorporationNationality = data2.NATIONALITY_CD;
            var residentialLocationRegisteredAddress = data2.REG_ADDRESS_CD;
            var tSectorType = data2.TSECTOR_CD;
            var pepType = data2.PEP_CD;
            var amlDescription = data2.AML_CD;
            var complexDescription = data2.COMPLEX_CD;
            this.setState({
              SelectedClientName: data2.CLIENTID,
              riskProfile: data2.CRP_RISK_PROFILE,
              // SelectedOwnerType: data2.OWNERTYPE_CD,
              SelectedOwnerTypeSCORE: data2.OWNERTYPE_SCORE,
              // SelectedNATIONALITYType: data2.COUNTRY_INCORP_CD,
              SelectedNATIONALITYTypeSCORE: data2.NATIONALITY_SCORE,
              // SelectedCOUNTRYYType: data2.NATIONALITY_CD,
              SelectedCOUNTRYTypeSCORE: data2.REG_ADDRESS_SCORE,
              // SelectedTSECTORType: data2.TSECTOR_CD,
              SelectedTSECTORTypeSCORE: data2.TSECTOR_SCORE,
              SelectedTSECTORText: data2.TSECTOR_TEXT,
              // SelectedPEPType: data2.PEP_CD,
              SelectedPEPTypeSCORE: data2.PEP_SCORE,
              // SelectedAMl: data2.AML_CD,
              SelectedAMLSCORE: data2.AML_SCORE,
              // SelectedCOMPLEXType: data2.COMPLEX_CD,
              SelectedCOMPLEXTypeSCORE: data2.COMPLEX_SCORE,
              selectedDate: data2.DATE_ENTERED,
            });
            this.setState({
              SearchButtonDisable: true,
              searchbuttonbackcolor: LIGHTGRAY_COLOR,
            });

            var clientNumber = data2.CLIENTID;

            var companyName = this.state.SelectedCompany;

            switch (companyName) {
              case "SWAN GENERAL":
                var data20 = {
                  MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
                  MAPINAME: "GETCRPCLIENTNAME",
                  MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
                  body: {
                    companyId: this.state.SelectedCompany || "",
                    ClientNo: clientNumber || "",
                  },
                };
                this.state.isloading = true;
                fnPostapiResponse(
                  process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
                  "PostApiMiddleWare",
                  data20,
                  process.env.REACT_APP_PORT_MIDDLEWARE
                )
                  .then((response) => {
                    var data21 = response.data[0][0];
                    if (data21.FULLNAME == undefined) {
                      this.setState({
                        ClientNameValue: "",
                      });
                    } else {
                      this.setState({
                        ClientNameValue:
                          data21.FULLNAME,
                      });
                    }
                  })
                  .catch((e) => console.log(e));
                break;
              case "SWAN LIFE":
                var data22 = {
                  MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
                  MAPINAME: "GETCRPCLIENTNAME",
                  MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
                  body: {
                    companyId: this.state.SelectedCompany || "",
                    ClientNo: this.state.SelectedClientName || "",
                  },
                };
                this.state.isloading = true;
                fnPostapiResponse(
                  process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
                  "PostApiMiddleWare",
                  data22,
                  process.env.REACT_APP_PORT_MIDDLEWARE
                )
                  .then((response) => {
                    var data23 = response.data[0][0];
                    if (data23.FULLNAME == undefined) {
                      this.setState({
                        ClientNameValue: "",
                      });
                    } else {
                      this.setState({
                        ClientNameValue:
                          data23.FULLNAME,
                      });
                    }
                  })
                  .catch((e) => console.log(e));
                break;
              default:
                console.log(this.state.SelectedCompany)
                console.log(NICandBRNValue)
                var data30 = {
                  MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
                  MAPINAME: "GETCRPCLIENTNAME",
                  MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
                  body: {
                    companyId: this.state.SelectedCompany || "",
                    NIC: NICandBRNValue || "",
                  },
                };
                this.state.isloading = true;
                fnPostapiResponse(
                  process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
                  "PostApiMiddleWare",
                  data30,
                  process.env.REACT_APP_PORT_MIDDLEWARE
                )
                  .then((response) => {
                    var data33 = response.data[0][0];
                    if (data33.FULLNAME == undefined) {
                      this.setState({
                        ClientNameValue: "",
                      });
                    } else {
                      this.setState({
                        ClientNameValue:
                        data33.FULLNAME,
                      });
                    }
                  })
                  .catch((e) => console.log(e));
                break;
            }

            var data5 = {
              MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
              MAPINAME: "GETCRPDETAILS",
              MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
              body: {
                OWNERTYPE_CD: ownerType || "",
                INCORPORATION_NATIONALITY_CD:
                  countryIncorporationNationality || "",
                RESIDENTIAL_LOCATION_ADDRESS:
                  residentialLocationRegisteredAddress || "",
                TSECTOR_CD: tSectorType || "",
                PEP_CD: pepType || "",
                AML_CD: amlDescription || "",
                COMPLEX_CD: complexDescription || "",
              },
            };
            this.state.isloading = true;
            fnPostapiResponse(
              process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
              "PostApiMiddleWare",
              data5,
              process.env.REACT_APP_PORT_MIDDLEWARE
            )
              .then((response) => {
                var data6 = response.data;
                if (
                  ownerType == null ||
                  ownerType == "" ||
                  ownerType == "NA" ||
                  ownerType == undefined ||
                  data6["OWNERTYP"][0][0].DESCRIPTION == null ||
                  data6["OWNERTYP"][0][0].DESCRIPTION == "" ||
                  data6["OWNERTYP"][0][0].DESCRIPTION == "NA" ||
                  data6["OWNERTYP"][0][0].DESCRIPTION == undefined
                ) {
                  this.setState({
                    SelectedOwnerType: "",
                  });
                } else {
                  this.setState({
                    SelectedOwnerType: data6["OWNERTYP"][0][0].DESCRIPTION,
                  });
                }

                if (
                  countryIncorporationNationality == null ||
                  countryIncorporationNationality == "" ||
                  countryIncorporationNationality == "NA" ||
                  countryIncorporationNationality == undefined ||
                  data6["NATIONALITY"][0][0] == null ||
                  data6["NATIONALITY"][0][0] == "" ||
                  data6["NATIONALITY"][0][0] == "NA" ||
                  data6["NATIONALITY"][0][0] == undefined
                ) {
                  this.setState({
                    SelectedNATIONALITYType: "",
                  });
                } else {
                  this.setState({
                    SelectedNATIONALITYType:
                      data6["NATIONALITY"][0][0].DESCRIPTION,
                  });
                }

                if (
                  residentialLocationRegisteredAddress == null ||
                  residentialLocationRegisteredAddress == "" ||
                  residentialLocationRegisteredAddress == "NA" ||
                  residentialLocationRegisteredAddress == undefined ||
                  data6["COUNTRY"][0][0] == null ||
                  data6["COUNTRY"][0][0] == "" ||
                  data6["COUNTRY"][0][0] == "NA" ||
                  data6["COUNTRY"][0][0] == undefined
                ) {
                  this.setState({
                    SelectedCOUNTRYYType: "",
                  });
                } else {
                  this.setState({
                    SelectedCOUNTRYYType: data6["COUNTRY"][0][0].DESCRIPTION,
                  });
                }

                if (
                  tSectorType == null ||
                  tSectorType == "" ||
                  tSectorType == "NA" ||
                  tSectorType == undefined ||
                  data6["TSECTOR"][0][0] == null ||
                  data6["TSECTOR"][0][0] == "" ||
                  data6["TSECTOR"][0][0] == "NA" ||
                  data6["TSECTOR"][0][0] == undefined
                ) {
                  this.setState({
                    SelectedTSECTORType: "",
                  });
                } else {
                  this.setState({
                    SelectedTSECTORType: data6["TSECTOR"][0][0].DESCRIPTION,
                  });
                }

                if (
                  pepType == null ||
                  pepType == "" ||
                  pepType == "NA" ||
                  pepType == undefined ||
                  data6["PEP"][0][0] == null ||
                  data6["PEP"][0][0] == "" ||
                  data6["PEP"][0][0] == "NA" ||
                  data6["PEP"][0][0] == undefined
                ) {
                  this.setState({
                    SelectedPEPType: "",
                  });
                } else {
                  this.setState({
                    SelectedPEPType: data6["PEP"][0][0].DESCRIPTION,
                  });
                }

                if (
                  amlDescription == null ||
                  amlDescription == "" ||
                  amlDescription == "NA" ||
                  amlDescription == undefined ||
                  data6["AML"][0][0] == null ||
                  data6["AML"][0][0] == "" ||
                  data6["AML"][0][0] == "NA" ||
                  data6["AML"][0][0] == undefined
                ) {
                  this.setState({
                    SelectedAMl: "",
                  });
                } else {
                  this.setState({
                    SelectedAMl: data6["AML"][0][0].DESCRIPTION,
                  });
                }

                if (
                  complexDescription == null ||
                  complexDescription == "" ||
                  complexDescription == undefined ||
                  data6["COMPLEX"][0][0] == null ||
                  data6["COMPLEX"][0][0] == "" ||
                  data6["COMPLEX"][0][0] == undefined
                ) {
                  this.setState({
                    SelectedCOMPLEXType: "",
                  });
                } else {
                  this.setState({
                    SelectedCOMPLEXType: data6["COMPLEX"][0][0].DESCRIPTION,
                  });
                }
                this.setState({
                  SearchButtonDisable: true,
                  searchbuttonbackcolor: LIGHTGRAY_COLOR,
                });
              })
              .catch((e) => console.log(e));
          }
        })
        .catch((e) => console.log(e));
    }

    if (NICValue == "" || NICValue == null) {
      var clientIdentification='';
      var clientIdFinal = '';

      if(this.state.SelectedClientName.length == 6){
        clientIdFinal = this.state.SelectedClientName
      }

      if(this.state.SelectedClientName.length < 6){
        clientIdentification = '000000' + this.state.SelectedClientName
        clientIdFinal = clientIdentification.substring(clientIdentification.length - 6)
      }

      if(this.state.SelectedClientName.length > 6){
        clientIdFinal = this.state.SelectedClientName.substring(this.state.SelectedClientName.length - 6);
      }

      console.log(clientIdFinal)

      var data4 = {
        MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
        MAPINAME: "GETCRPDETAILSCLIENTID",
        MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
        body: {
          companyId: this.state.SelectedCompany || "",
          ClientNo: clientIdFinal || "",
        },
      };
      this.state.isloading = true;
      fnPostapiResponse(
        process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
        "PostApiMiddleWare",
        data4,
        process.env.REACT_APP_PORT_MIDDLEWARE
      )
        .then((response) => {
          var data3 = response.data[0][0];
          if (data3 == undefined) {
            alert("No data available for this search");
          } else {
            var fullNIC = data3.NICVALUE;

            this.fnsetNICTypeRefinitSearch(data3.CLIENT_TYPE);
            var nicArray = fullNIC.split("-");
            this.setState({
              SelectedClientType: data3.CLIENT_TYPE,
              SelectedNICType: nicArray[0],
              SelectedNic: nicArray[1],
              selectedDropCountry: nicArray[2],
            });

            var companyName = this.state.SelectedCompany;

            switch (companyName) {
              case "SWAN GENERAL":
                var data20 = {
                  MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
                  MAPINAME: "GETCRPCLIENTNAME",
                  MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
                  body: {
                    companyId: this.state.SelectedCompany || "",
                    ClientNo: clientIdFinal || "",
                  },
                };
                this.state.isloading = true;
                fnPostapiResponse(
                  process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
                  "PostApiMiddleWare",
                  data20,
                  process.env.REACT_APP_PORT_MIDDLEWARE
                )
                  .then((response) => {
                    var data21 = response.data[0][0];
                    console.log("SWAN GENERAL");
                    console.log(data21);
                    if (data21.FULLNAME == undefined) {
                      this.setState({
                        ClientNameValue: "",
                      });
                    } else {
                      this.setState({
                        ClientNameValue:
                          data21.FULLNAME,
                      });
                    }
                  })
                  .catch((e) => console.log(e));
                break;
              case "SWAN LIFE":
                var data22 = {
                  MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
                  MAPINAME: "GETCRPCLIENTNAME",
                  MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
                  body: {
                    companyId: this.state.SelectedCompany || "",
                    ClientNo: clientIdFinal || "",
                  },
                };
                this.state.isloading = true;
                fnPostapiResponse(
                  process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
                  "PostApiMiddleWare",
                  data22,
                  process.env.REACT_APP_PORT_MIDDLEWARE
                )
                  .then((response) => {
                    var data23 = response.data[0][0];
                    console.log("SWAN LIFE");
                    console.log(data23);
                    if (data23.FULLNAME == undefined) {
                      this.setState({
                        ClientNameValue: "",
                      });
                    } else {
                      this.setState({
                        ClientNameValue:
                          data23.FULLNAME,
                      });
                    }
                  })
                  .catch((e) => console.log(e));
                break;
              default:
                console.log(this.state.SelectedCompany)
                console.log(fullNIC)
                var data60 = {
                  MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
                  MAPINAME: "GETCRPCLIENTNAME",
                  MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
                  body: {
                    companyId: this.state.SelectedCompany || "",
                    NIC: fullNIC || "",
                  },
                };
                this.state.isloading = true;
                fnPostapiResponse(
                  process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
                  "PostApiMiddleWare",
                  data60,
                  process.env.REACT_APP_PORT_MIDDLEWARE
                )
                  .then((response) => {
                    var data63 = response.data[0][0];
                    if (data63.FULLNAME == undefined) {
                      this.setState({
                        ClientNameValue: "",
                      });
                    } else {
                      this.setState({
                        ClientNameValue:
                          data63.FULLNAME,
                      });
                    }
                  })
                  .catch((e) => console.log(e));
                break;
            }

            var data10 = {
              MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
              MAPINAME: "GETCRPDETAILSNIC",
              MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
              body: {
                NIC: fullNIC || "",
                companyId: this.state.SelectedCompany || "",
              },
            };
            this.state.isloading = true;
            fnPostapiResponse(
              process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
              "PostApiMiddleWare",
              data10,
              process.env.REACT_APP_PORT_MIDDLEWARE
            )
              .then((response) => {
                var data11 = response.data[0][0];

                if (data11 == undefined) {
                  alert("No data available for this search");
                } else {
                  var ownerType = data11.OWNERTYPE_CD;
                  var countryIncorporationNationality = data11.NATIONALITY_CD;
                  var residentialLocationRegisteredAddress =
                    data11.REG_ADDRESS_CD;
                  var tSectorType = data11.TSECTOR_CD;
                  var pepType = data11.PEP_CD;
                  var amlDescription = data11.AML_CD;
                  var complexDescription = data11.COMPLEX_CD;
                  this.setState({
                    riskProfile: data11.CRP_RISK_PROFILE,
                    // SelectedOwnerType: data2.OWNERTYPE_CD,
                    SelectedOwnerTypeSCORE: data11.OWNERTYPE_SCORE,
                    // SelectedNATIONALITYType: data2.COUNTRY_INCORP_CD,
                    SelectedNATIONALITYTypeSCORE: data11.NATIONALITY_SCORE,
                    // SelectedCOUNTRYYType: data2.NATIONALITY_CD,
                    SelectedCOUNTRYTypeSCORE: data11.REG_ADDRESS_SCORE,
                    // SelectedTSECTORType: data2.TSECTOR_CD,
                    SelectedTSECTORTypeSCORE: data11.TSECTOR_SCORE,
                    SelectedTSECTORText: data11.TSECTOR_TEXT,
                    // SelectedPEPType: data2.PEP_CD,
                    SelectedPEPTypeSCORE: data11.PEP_SCORE,
                    // SelectedAMl: data2.AML_CD,
                    SelectedAMLSCORE: data11.AML_SCORE,
                    // SelectedCOMPLEXType: data2.COMPLEX_CD,
                    SelectedCOMPLEXTypeSCORE: data11.COMPLEX_SCORE,
                    selectedDate: data11.DATE_ENTERED,
                  });
                  this.setState({
                    SearchButtonDisable: true,
                    searchbuttonbackcolor: LIGHTGRAY_COLOR,
                  });

                  var data12 = {
                    MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
                    MAPINAME: "GETCRPDETAILS",
                    MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
                    body: {
                      OWNERTYPE_CD: ownerType || "",
                      INCORPORATION_NATIONALITY_CD:
                        countryIncorporationNationality || "",
                      RESIDENTIAL_LOCATION_ADDRESS:
                        residentialLocationRegisteredAddress || "",
                      TSECTOR_CD: tSectorType || "",
                      PEP_CD: pepType || "",
                      AML_CD: amlDescription || "",
                      COMPLEX_CD: complexDescription || "",
                    },
                  };
                  this.state.isloading = true;
                  fnPostapiResponse(
                    process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
                    "PostApiMiddleWare",
                    data12,
                    process.env.REACT_APP_PORT_MIDDLEWARE
                  )
                    .then((response) => {
                      var data13 = response.data;
                      if (
                        ownerType == null ||
                        ownerType == "" ||
                        ownerType == "NA" ||
                        ownerType == undefined ||
                        data13["OWNERTYP"][0][0].DESCRIPTION == null ||
                        data13["OWNERTYP"][0][0].DESCRIPTION == "" ||
                        data13["OWNERTYP"][0][0].DESCRIPTION == "NA" ||
                        data13["OWNERTYP"][0][0].DESCRIPTION == undefined
                      ) {
                        this.setState({
                          SelectedOwnerType: "",
                        });
                      } else {
                        this.setState({
                          SelectedOwnerType:
                            data13["OWNERTYP"][0][0].DESCRIPTION,
                        });
                      }

                      if (
                        countryIncorporationNationality == null ||
                        countryIncorporationNationality == "" ||
                        countryIncorporationNationality == "NA" ||
                        countryIncorporationNationality == undefined ||
                        data13["NATIONALITY"][0][0] == null ||
                        data13["NATIONALITY"][0][0] == "" ||
                        data13["NATIONALITY"][0][0] == "NA" ||
                        data13["NATIONALITY"][0][0] == undefined
                      ) {
                        this.setState({
                          SelectedNATIONALITYType: "",
                        });
                      } else {
                        this.setState({
                          SelectedNATIONALITYType:
                            data13["NATIONALITY"][0][0].DESCRIPTION,
                        });
                      }

                      if (
                        residentialLocationRegisteredAddress == null ||
                        residentialLocationRegisteredAddress == "" ||
                        residentialLocationRegisteredAddress == "NA" ||
                        residentialLocationRegisteredAddress == undefined ||
                        data13["COUNTRY"][0][0] == null ||
                        data13["COUNTRY"][0][0] == "" ||
                        data13["COUNTRY"][0][0] == "NA" ||
                        data13["COUNTRY"][0][0] == undefined
                      ) {
                        this.setState({
                          SelectedCOUNTRYYType: "",
                        });
                      } else {
                        this.setState({
                          SelectedCOUNTRYYType:
                            data13["COUNTRY"][0][0].DESCRIPTION,
                        });
                      }

                      if (
                        tSectorType == null ||
                        tSectorType == "" ||
                        tSectorType == "NA" ||
                        tSectorType == undefined ||
                        data13["TSECTOR"][0][0] == null ||
                        data13["TSECTOR"][0][0] == "" ||
                        data13["TSECTOR"][0][0] == "NA" ||
                        data13["TSECTOR"][0][0] == undefined
                      ) {
                        this.setState({
                          SelectedTSECTORType: "",
                        });
                      } else {
                        this.setState({
                          SelectedTSECTORType:
                            data13["TSECTOR"][0][0].DESCRIPTION,
                        });
                      }

                      if (
                        pepType == null ||
                        pepType == "" ||
                        pepType == "NA" ||
                        pepType == undefined ||
                        data13["PEP"][0][0] == null ||
                        data13["PEP"][0][0] == "" ||
                        data13["PEP"][0][0] == "NA" ||
                        data13["PEP"][0][0] == undefined
                      ) {
                        this.setState({
                          SelectedPEPType: "",
                        });
                      } else {
                        this.setState({
                          SelectedPEPType: data13["PEP"][0][0].DESCRIPTION,
                        });
                      }

                      if (
                        amlDescription == null ||
                        amlDescription == "" ||
                        amlDescription == "NA" ||
                        amlDescription == undefined ||
                        data13["AML"][0][0] == null ||
                        data13["AML"][0][0] == "" ||
                        data13["AML"][0][0] == "NA" ||
                        data13["AML"][0][0] == undefined
                      ) {
                        this.setState({
                          SelectedAMl: "",
                        });
                      } else {
                        this.setState({
                          SelectedAMl: data13["AML"][0][0].DESCRIPTION,
                        });
                      }

                      if (
                        complexDescription == null ||
                        complexDescription == "" ||
                        complexDescription == undefined ||
                        data13["COMPLEX"][0][0] == null ||
                        data13["COMPLEX"][0][0] == "" ||
                        data13["COMPLEX"][0][0] == undefined
                      ) {
                        this.setState({
                          SelectedCOMPLEXType: "",
                        });
                      } else {
                        this.setState({
                          SelectedCOMPLEXType:
                            data13["COMPLEX"][0][0].DESCRIPTION,
                        });
                      }
                      this.setState({
                        SearchButtonDisable: true,
                        searchbuttonbackcolor: LIGHTGRAY_COLOR,
                      });
                    })
                    .catch((e) => console.log(e));
                }
              })
              .catch((e) => console.log(e));
          }
        })
        .catch((e) => console.log(e));
    }
  }

  componentDidMount() {
    // window.addEventListener('beforeunload', this.handleLeavePage)

    this.setState({
      isadmin:
        sessionStorage.getItem("isadminFlag") == "true" 
          ? true
          : false,
      isadminSwitch:
        sessionStorage.getItem("isadminFlag") == "true" 
          ? false
          : true,
    });

    var data = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "GETCDDCRMDDL",
      MAPIPORT: "" + process.env.REACT_APP_MPORT + "",
      body: "",
    };
    fnGETapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "GetApiMiddleWare",
      data,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response) => {
        var data = response.data;
        if (data["OWNERTYP"] != undefined) {
          this.setState({
            OWNERTYPE: data["OWNERTYP"][0],
            //PREMIUM:data["PREMIUM"][0],
            NATIONALITY: data["NATIONALITY"][0],
            COUNTRY: data["COUNTRY"][0],
            Dropcountry: data["COUNTRY"][0],
            TSECTOR: data["TSECTOR"][0],
            INTRO: data["INTRO"][0],
            //BENEF:data["BENEF"][0],
            SRCFUND: data["SRCFUND"][0],
            PEP: data["PEP"][0],
            AML: data["AML"][0],
            COMPLEX: data["COMPLEX"][0],
            CINCORP: data["CINCORP"][0],
            CompanyType: data["Company"][0],
            ClientType: data["ClientType"][0],
            SelectedCompany: "SWAN GENERAL",
            SelectedClientType: "CORPORATE",
            SelectedClientName: "",
            SelectedBRN: "",
          });
          this.fnsetclientType("CORPORATE");

          this.FntoSetProductypes("PRODUCTSGL");
          this.setState({
            selectedOption: "ONBOARDING",
          });
          this.setRadioState("ONBOARDING");
        } else {
          alert(data);
        }
        this.fnsetdatafromurl();
      })
      .catch((e) => console.log(e));
  }
  fnsetdatafromurl() {
    // this.state.selectedUser = sessionStorage.getItem('username')
    //     this.state.selectedPass = sessionStorage.getItem('password')
    //     this.state.IsWindowsAuth = sessionStorage.getItem('IsWindowsAuth')
    // this.state.SelectedNic = sessionStorage.getItem("NIC")
    // alert(sessionStorage.getItem('ClientNo'))

    this.state.SelectedClientName = sessionStorage.getItem("ClientNo");
    this.setState({ SelectedCompany: sessionStorage.getItem("Company") });
    // this.state.SelectedClientType = sessionStorage.getItem("ClientType");
    // this.state.selectedDropCountry = sessionStorage.getItem('Country')
    // var nic = this.state.SelectedNic.split("-")
    // // console.log("NIC Wala",nic)
    // if (nic.length > 1) {
    //     this.state.SelectedNICType = nic[0]
    //     this.state.SelectedNic = nic[1]
    // }
    // else {
    //     this.state.NICdrop = "NIC"
    //     this.state.SelectedNic = nic[0]
    // }
    this.fnsetclientType(this.state.SelectedClientType);

    if (sessionStorage.getItem("isFromWindowApplication")) {
      let cmp = sessionStorage.getItem("Company");

      this.setState({
        selectedOption: "ONBOARDING",
      });
      this.FntoSetProductypes(cmp);
    }
  }

  FntocheckpassDrop(pasdrp) {
    if (pasdrp == "PAS" || pasdrp == "LEI" || pasdrp == "CRN") {
      this.setState({ displaycountry: "block" });
    } else {
      this.setState({ displaycountry: "none" });
    }
  }
  fnsetclientType(clnttype) {
    var data = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "GETNICBRN",
      MAPIPORT: process.env.REACT_APP_MPORT,
      body: clnttype,
    };
    fnGETapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "GetApiMiddleWare",
      data,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response) => {
        this.setState({ NICdrop: response.data["nicbrnval"][0] });
        // console.log("ddd",this.state.NICdrop)
        if (clnttype == "CORPORATE")
          this.setState({
            SelectedNICType: "BRN",
            SelectedNicLabel: "BRN",
          });
        else {
          this.setState({
            SelectedNICType: "NIC",
            SelectedNicLabel: "NIC",
          });
        }
        this.FntocheckpassDrop(this.state.SelectedNICType);
      })
      .catch((e) => console.log(e));
  }
  isEven(n) {
    return n % 2 == 0;
  }
  handleCancelClick() {
    var r = window.confirm("Do you really want Cancel ?");
    if (r == true) window.location.reload();
  }
  handleNewCDDClick() {
    var r = window.confirm(
      "Do you really want to calculate New Risk Profiling ?"
    );
    if (r == true) {
      this.clearrelaod();
    }
  }

  clearScreen() {
    // this.componentDidMount();
    this.setState({ displaycountry: "none" });
    this.setState({
      SearchButtonDisable: false,
      searchbuttonbackcolor: BLUE_COLOR,
    });
    // this.setState({
    //   ClientNameValue: "",
    // });
    this.state.SelectedClientName = "";
    this.state.SelectedClientType = "CORPORATE";
    this.fnsetNICTypeRefinitSearch("CORPORATE");
    this.fnsetclientType("CORPORATE");
    this.state.SelectedNICType = "BRN";
    this.state.riskProfile = "";
    this.state.selectedDate = "";
    this.state.SelectedNic = "";
    this.state.selectedDropCountry = "";
    this.state.SelectedCINCORPType = "";
    this.state.SelectedOwnerType = "";
    this.state.SelectedOwnerTypeSCORE = 0;
    this.state.SelectedProductType = "";
    this.state.SelectedProductTypeSCORE = 0;
    this.state.SelectedPREMIUMType = "";
    this.state.SelectedPREMIUMTypeSCORE = 0;
    this.state.SelectedNATIONALITYType = "";
    this.state.SelectedNATIONALITYTypeSCORE = 0;
    this.state.SelectedCOUNTRYYType = "";
    this.state.SelectedCOUNTRYTypeSCORE = 0;
    this.state.SelectedTSECTORType = "";
    this.state.SelectedTSECTORText = "";
    this.state.SelectedTSECTORTypeSCORE = 0;
    this.state.SelectedINTROType = "";
    this.state.SelectedINTROTypeSCORE = 0;
    this.state.SelectedSRCFUNDType = "";
    this.state.SelectedSRCFUNDTypeSCORE = 0;
    this.state.SelectedPEPType = "";
    this.state.SelectedPEPTypeSCORE = 0;
    this.state.SelectedAMl = "";
    this.state.SelectedAMLSCORE = 0;
    this.state.SelectedCOMPLEXType = "";
    this.state.SelectedCOMPLEXTypeSCORE = 0;
    this.state.SelectedBENEFType = "";
    this.state.SelectedBENEFTypeSCORE = 0;
    this.state.ClientNameValue = "";
  }

  clearrelaod() {
    this.setState({ displaycountry: "none" });
    this.state.riskProfile = "";
    this.state.selectedDate = "";
    this.state.SelectedNic = "";
    this.state.SelectedCompany = "";
    this.state.SelectedClientName = "";
    this.state.SelectedClientType = "";
    this.state.SelectedNICType = "";
    this.state.SelectedBRN = "";
    this.state.SelectedCINCORPType = "";
    this.state.SelectedOwnerType = "";
    this.state.SelectedOwnerTypeSCORE = 0;
    this.state.SelectedProductType = "";
    this.state.SelectedProductTypeSCORE = 0;
    this.state.SelectedPREMIUMType = "";
    this.state.SelectedPREMIUMTypeSCORE = 0;
    this.state.SelectedNATIONALITYType = "";
    this.state.SelectedNATIONALITYTypeSCORE = 0;
    this.state.SelectedCOUNTRYYType = "";
    this.state.SelectedCOUNTRYTypeSCORE = 0;
    this.state.SelectedTSECTORType = "";
    this.state.SelectedTSECTORText = "";
    this.state.SelectedTSECTORTypeSCORE = 0;
    this.state.SelectedINTROType = "";
    this.state.SelectedINTROTypeSCORE = 0;
    this.state.SelectedSRCFUNDType = "";
    this.state.SelectedSRCFUNDTypeSCORE = 0;
    this.state.SelectedPEPType = "";
    this.state.SelectedPEPTypeSCORE = 0;
    this.state.SelectedAMl = "";
    this.state.SelectedAMLSCORE = 0;
    this.state.SelectedCOMPLEXType = "";
    this.state.SelectedCOMPLEXTypeSCORE = 0;
    this.state.SelectedBENEFType = "";
    this.state.SelectedBENEFTypeSCORE = 0;
    this.setState({
      SelectedCompany: "",
      SearchButtonDisable: false,
    });
  }
  handeltextChange(e, key) {
    this.setState({ key: e.target.value });
    this.state[key] = e.target.value;
    // alert("change "+ this.state.NIC+"")
  }
  Nicchecking() {
    if (this.state.SelectedNic.trim() == "") {
      alert("Please select either NIC or BRN");
    } else {
      var data = {
        MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
        MAPINAME: "ValidateNIC",
        MAPIPORT: "" + process.env.REACT_APP_MPORT1 + "",
        body: {
          strFirstCharToCheck: "",
          strSurname: "",
          strMaiden: "",
          strSex: "",
          strDOB: "",
          strCountryCode: "",
          strNic: this.state.SelectedNic.trim(),
          strStatus: "",
          strMessage: "",
          blCheckDigitOnly: true,
        },
      };
      fnPostapiResponse(
        process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
        "PostApiMiddleWare",
        data,
        process.env.REACT_APP_PORT_MIDDLEWARE
      )
        .then((response) => {
          this.state.nivvaliderror = response.data;
          if (
            this.state.nivvaliderror == true ||
            this.state.SelectedBRN.trim() != "" ||
            this.state.SelectedNICType != "NIC"
          ) {
            this.FntovalidateDrop();
            if (this.state.validateAlloptions) {
              this.FntoSumScore();

              var data1 = {
                MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
                MAPINAME: "getrisk",
                MAPIPORT: process.env.REACT_APP_MPORT,
                body: this.state.TotalRiskCount,
              };
              fnGETapiResponse(
                process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
                "GetApiMiddleWare",
                data1,
                process.env.REACT_APP_PORT_MIDDLEWARE
              )
                .then((response2) => {
                  var data = response2.data;
                  this.setState({
                    riskProfile: data,
                  });
                  this.saveData();
                })
                .catch((e) => console.log(e));
            }
          } else {
            alert(this.state.nivvaliderror);
          }
        })
        .catch((e) => console.log(e));
    }
  }

  handleSearchClick(e) {
    this.setState({ showalertPopup: true });
  }
  handlesetalert(value) {
    if (value == "NO") this.Nicchecking();
    this.setState({ showalertPopup: false });
  }
  FntovalidateDrop() {
    // console.log("",this.state.SelectedOwnerType + " Pt " +  this.state.SelectedProductType + " Premium " + this.state.SelectedPREMIUMType
    // + " NAtion " +this.state.SelectedNATIONALITYType+ " country " + this.state.SelectedCOUNTRYYType + " tsec " +this.state.SelectedTSECTORType
    // + " introd " +this.state.SelectedINTROType+ " srcfund " + this.state.SelectedSRCFUNDType+ " Pepty " +this.state.SelectedPEPType
    // + " aml " +this.state.SelectedAMl+ " comp " +this.state.SelectedCOMPLEXType + " oinco " + this.state.SelectedCINCORPType)

    if (
      this.state.SelectedOwnerType == "" ||
      this.state.SelectedProductType == "" ||
      this.state.SelectedPREMIUMType == "" ||
      this.state.SelectedNATIONALITYType == "" ||
      this.state.SelectedCOUNTRYYType == "" ||
      this.state.SelectedTSECTORType == "" ||
      this.state.SelectedINTROType == "" ||
      this.state.SelectedSRCFUNDType == "" ||
      this.state.SelectedPEPType == "" ||
      this.state.SelectedAMl == "" ||
      this.state.SelectedCOMPLEXType == ""
    ) {
      alert("All dropdowns must be filled to proceed.");
      this.state.validateAlloptions = false;
    } else this.state.validateAlloptions = true;
  }
  clearddlvalueswithscores() {
    this.state.riskProfile = "";
    this.state.selectedDate = "";
    this.state.SelectedNic = "";
    this.state.SelectedBRN = "";
    this.state.SelectedClientName = "";
    this.state.SelectedClientType = "";
    this.state.SelectedTSECTORText = "";
    this.state.SelectedCINCORPType = "";
    this.state.SelectedOwnerType = "";
    this.state.SelectedOwnerTypeSCORE = 0;
    this.state.SelectedProductType = "";
    this.state.SelectedProductTypeSCORE = 0;
    this.state.SelectedPREMIUMType = "";
    this.state.SelectedPREMIUMTypeSCORE = 0;
    this.state.SelectedNATIONALITYType = "";
    this.state.SelectedNATIONALITYTypeSCORE = 0;
    this.state.SelectedCOUNTRYYType = "";
    this.state.SelectedCOUNTRYTypeSCORE = 0;
    this.state.SelectedTSECTORType = "";
    this.state.SelectedTSECTORTypeSCORE = 0;
    this.state.SelectedINTROType = "";
    this.state.SelectedINTROTypeSCORE = 0;
    this.state.SelectedSRCFUNDType = "";
    this.state.SelectedSRCFUNDTypeSCORE = 0;
    this.state.SelectedPEPType = "";
    this.state.SelectedPEPTypeSCORE = 0;
    this.state.SelectedAMl = "";
    this.state.SelectedAMLSCORE = 0;
    this.state.SelectedCOMPLEXType = "";
    this.state.SelectedCOMPLEXTypeSCORE = 0;
    this.state.SelectedBENEFType = "";
    this.state.SelectedBENEFTypeSCORE = 0;
  }

  saveData() {
    var NICandBRNValue = "";
    if (this.state.SelectedNICTypety == "PAS") {
      NICandBRNValue +=
        "PASS-" + this.state.SelectedNic.trim() + "-" + this.state.Dropcountry;
    }

    NICandBRNValue +=
      this.SelectedNICType + "-" + this.state.SelectedNic.trim();

    // POST request
    var data1 = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "POSTCDDCRMDDL",
      MAPIPORT: process.env.REACT_APP_MPORT,
      body: {
        NIC: "" + NICandBRNValue + "",
        companyId: "" + this.state.SelectedCompany + "",
        clientId: "" + this.state.SelectedClientName + "",
        RISK_PROFILE: "" + this.state.riskProfile.toUpperCase() + "",
        TOTAL_RISK_SCORE: "" + this.state.TotalRiskCount + "",
        PRODUCT_CD: "" + this.state.SelectedProductType + "",
        PRODUCT_SCORE: "" + this.state.SelectedProductTypeSCORE + "",
        PREMIUM_CD: "" + this.state.SelectedPREMIUMType + "",
        PREMIUM_SCORE: "" + this.state.SelectedPREMIUMTypeSCORE + "",
        NATIONALITY_CD: "" + this.state.SelectedNATIONALITYType + "",
        NATIONALITY_SCORE: "" + this.state.SelectedNATIONALITYTypeSCORE + "",
        TSECTOR_CD: "" + this.state.SelectedTSECTORType + "",
        TSECTOR_SCORE: "" + this.state.SelectedTSECTORTypeSCORE + "",
        TSECTOR_TEXT: "" + this.state.SelectedTSECTORText + "",
        INTRO_CD: "" + this.state.SelectedINTROType + "",
        INTRO_SCORE: "" + this.state.SelectedINTROTypeSCORE + "",
        BENEF_CD: "" + this.state.SelectedBENEFType + "",
        BENEF_SCORE: "" + this.state.SelectedBENEFTypeSCORE + "",
        SRCFUND_CD: "" + this.state.SelectedSRCFUNDType + "",
        SRCFUND_SCORE: "" + this.state.SelectedSRCFUNDTypeSCORE + "",
        PEP_CD: "" + this.state.SelectedPEPType + "",
        PEP_SCORE: "" + this.state.SelectedPEPTypeSCORE + "",
        AML_CD: "" + this.state.SelectedAMl + "",
        AML_SCORE: "" + this.state.SelectedAMLSCORE + "",
        COMPLEX_CD: "" + this.state.SelectedCOMPLEXType + "",
        COMPLEX_SCORE: "" + this.state.SelectedCOMPLEXTypeSCORE + "",
        UBO_LOCATION_CD: "" + this.state.SelectedCOUNTRYYType + "",
        UBO_LOCATION_SCORE: "" + this.state.SelectedCOUNTRYTypeSCORE + "",
        OWNERTYPE_CD: "" + this.state.SelectedOwnerType + "",
        OWNERTYPE_SCORE: "" + this.state.SelectedOwnerTypeSCORE + "",
        COUNTRY_INCORP_CD: "" + this.state.SelectedCINCORPType + "",
        COUNTRY_INCORP_SCORE: "" + this.state.SelectedCINCORPTypeSCORE + "",
        CLIENT_TYPE: "" + this.state.SelectedClientType + "",
        USERID: "" + sessionStorage.getItem("username").toUpperCase() + "",
        DATE_ENTERED: "" + this.state.selectedDate + "",
      },
    };
    fnPostapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "PostApiMiddleWare",
      data1,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response) => {
        var data = response.data;
        if (data == "Data Already Exist ") {
          this.setState({
            SavebuttonDisable: false,
            savebuttonbackcolor: BLUE_COLOR,
            showNewCDDC: false,
          });
          alert("Client already has a risk profile for this product.");
        } else {
          alert(
            "Risk profile is: " +
              this.state.riskProfile +
              ". Record has been successfully saved! Please proceed with CDD."
          );
          this.setState({
            SavebuttonDisable: true,
            savebuttonbackcolor: LIGHTGRAY_COLOR,
            showNewCDDC: true,
          });
        }
      })
      .catch((e) => console.log(e));
  }
  FnforotherOccupation(Newpcc, e) {
    // alert(Newpcc)
    this.setState({
      SelectedTSECTORType: e.target.value,
      SelectedTSECTORTypeSCORE: Number(
        e.currentTarget.getAttribute("data-score")
      ),
    });
    if (e.target.value == "OTH") {
      var data1 = {
        MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
        MAPINAME: "getOccupation",
        MAPIPORT: process.env.REACT_APP_MPORT,
        body: Newpcc,
      };
      fnGETapiResponse(
        process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
        "GetApiMiddleWare",
        data1,
        process.env.REACT_APP_PORT_MIDDLEWARE
      )
        .then((response2) => {
          var data = response2.data;
          this.setState({
            Occupation: data[0],
            ShowOccupation: true,
          });
        })
        .catch((e) => console.log(e));
    } else {
      this.state.ShowOccupation = false;
    }
  }

  SetDDLComapnyValues(e) {
    var SelectedProType = "PRODUCTSGL";
    var SelectedPrimeum = "PREMIUMSGL";
    var SelectedPribenf = "";
    switch (e) {
      case "SWAN LIFE":
        this.state.diableRadio = false;
        this.state.selectedProductLabel = "Product Type :";
        this.state.selectedPremiumLabel = "Amount of Monthly/Single Premium :";
        this.state.selectedbeneficiaryLabel =
          "Do you know the beneficiary of the policy (SLL) :";
        // this.state.showBeneficiaryComponent = true;
        SelectedProType = "PRODUCTSLL";
        SelectedPrimeum = "PREMIUMSLL";
        SelectedPribenf = "OPTQ1SLL";
        break;
      case "SWAN GENERAL":
        this.state.diableRadio = true;
        this.state.selectedProductLabel = "Product Type :";
        this.state.selectedPremiumLabel = "Amount of Premium :";
        // this.state.showBeneficiaryComponent = false;
        SelectedProType = "PRODUCTSGL";
        SelectedPrimeum = "PREMIUMSGL";
        SelectedPribenf = "";
        break;
      case "SWAN WEALTH":
        this.state.diableRadio = true;
        this.state.selectedProductLabel = "Product / Service Type :";
        this.state.selectedPremiumLabel = "Amount of Investment :";
        SelectedProType = "PRODUCTSWL";
        SelectedPrimeum = "PREMIUMSWL";
        SelectedPribenf = "";
        // this.state.showBeneficiaryComponent = false;
        break;
      case "SWAN PENSIONS":
        this.state.diableRadio = false;
        this.state.selectedProductLabel = "Product Type :";
        this.state.selectedPremiumLabel = "Amount of Contribution :";
        this.state.selectedbeneficiaryLabel = "Number of Members :";
        // this.state.showBeneficiaryComponent = true;
        SelectedProType = "PRODUCTSPL";
        SelectedPrimeum = "PREMIUMSPL";
        SelectedPribenf = "OPTQ1SPL";
        break;
      case "SWAN SECURITIES":
        this.state.diableRadio = false;
        this.state.selectedProductLabel = "Product / Service Type :";
        this.state.selectedPremiumLabel = "Amount of Investment :";
        this.state.selectedbeneficiaryLabel =
          "Has there been allegations against Client ?";
        // this.state.showBeneficiaryComponent = true;
        SelectedProType = "PRODUCTSSL";
        SelectedPrimeum = "PREMIUMSSL";
        SelectedPribenf = "OPTQ1SSL";
        break;
      case "SWAN SSR":
        this.state.diableRadio = true;
        this.state.selectedProductLabel = "Product / Service Type :";
        this.state.selectedPremiumLabel = "Amount of Investment :";
        // this.state.showBeneficiaryComponent = false;
        SelectedProType = "PRODUCTSSR";
        SelectedPrimeum = "PREMIUMSSR";
        SelectedPribenf = "";
        break;
      default:
        this.state.selectedProductLabel = "Product Type :";
        this.state.selectedPremiumLabel = "Amount of Contribution :";
        this.state.selectedbeneficiaryLabel = "Number of Members :";
        SelectedProType = "PRODUCTSGL";
        SelectedPrimeum = "PREMIUMSGL";
        SelectedPribenf = "";
        break;
    }
    return [SelectedProType, SelectedPrimeum, SelectedPribenf];
  }

  FntoSetProductypes(e) {
    // alert(e)
    // this.clearddlvalueswithscores();
    var SelectedProType = "PRODUCTSGL";
    var SelectedPrimeum = "PREMIUMSGL";
    var SelectedPribenf = "";

    this.setState({
      selectedOption: "ONBOARDING",
    });
    this.setRadioState("ONBOARDING");
    var getSelectedValues = this.SetDDLComapnyValues(e);
    SelectedProType = getSelectedValues[0];
    SelectedPrimeum = getSelectedValues[1];
    SelectedPribenf = getSelectedValues[2];

    var data1 = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "getOccupation",
      MAPIPORT: process.env.REACT_APP_MPORT,
      body: SelectedProType,
    };
    fnGETapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "GetApiMiddleWare",
      data1,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response2) => {
        var data = response2.data;
        this.setState({
          PRODUCT: data[0],
        });
      })
      .catch((e) => console.log(e));

    var data1 = {
      MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
      MAPINAME: "getOccupation",
      MAPIPORT: process.env.REACT_APP_MPORT,
      body: SelectedPrimeum,
    };
    fnGETapiResponse(
      process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
      "GetApiMiddleWare",
      data1,
      process.env.REACT_APP_PORT_MIDDLEWARE
    )
      .then((response2) => {
        var data = response2.data;
        this.setState({
          PREMIUM: data[0].sort(this.GetSortOrderfn("SCORE")),
        });
      })
      .catch((e) => console.log(e));

    if (SelectedPribenf != "") {
      var data1 = {
        MAPIURL: "" + process.env.REACT_APP_SOURCE_URL + "",
        MAPINAME: "getOccupation",
        MAPIPORT: process.env.REACT_APP_MPORT,
        body: SelectedPribenf,
      };
      fnGETapiResponse(
        process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,
        "GetApiMiddleWare",
        data1,
        process.env.REACT_APP_PORT_MIDDLEWARE
      )
        .then((response2) => {
          var data = response2.data;
          this.setState({
            BENEF: data[0],
          });
        })
        .catch((e) => console.log(e));
    }
  }

  setRadioState(e) {
    // this.clearddlvalueswithscores();
    this.setState({
      selectedOption: e,
    });

    if (e == "ONBOARDING") {
      this.setState({
        disableSelectedINTROType: false,
        SelectedINTROType: "",
        SelectedSRCFUNDType: "",
        disableBenef: false,
        SelectedBENEFType: "",
        Nainpayment: true,
        disableSelectedpaymentType: false,
        NANBenef: true,
        NANSourceOfFund: true,
        NANSourceOfIntroduction: true,
      });
      if (this.state.SelectedCompany != "") {
        this.SetDDLComapnyValues(this.state.SelectedCompany);
      }
    } else {
      this.setState({
        selectedPremiumLabel: "Amount Of Benefit Payable",
        SelectedINTROType: "NA",
        disableSelectedINTROType: true,
        disableSelectedpaymentType: false,
        SelectedSRCFUNDType: "NA",
        disableBenef: false,
        SelectedBENEFType: "",
        Nainpayment: false,
        NANBenef: true,
        NANSourceOfFund: false,
        NANSourceOfIntroduction: false,
        disableSelectedpaymentType: true,
        SelectedPREMIUMType: "NA",
      });
      if (
        this.state.SelectedCompany == "SWAN LIFE" ||
        this.state.SelectedCompany == "SWAN PENSIONS"
      ) {
        this.setState({
          disableBenef: true,
          SelectedBENEFType: "NA",
          NANBenef: false,
        });
      }
    }
  }

  //Comparer Function
  GetSortOrderfn(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    };
  }

  FntoSumScore() {
    this.state.TotalRiskCount =
      this.state.SelectedOwnerTypeSCORE +
      this.state.SelectedProductTypeSCORE +
      this.state.SelectedPREMIUMTypeSCORE +
      this.state.SelectedNATIONALITYTypeSCORE +
      this.state.SelectedCOUNTRYTypeSCORE +
      this.state.SelectedTSECTORTypeSCORE +
      this.state.SelectedINTROTypeSCORE +
      this.state.SelectedBENEFTypeSCORE +
      this.state.SelectedSRCFUNDTypeSCORE +
      this.state.SelectedPEPTypeSCORE +
      this.state.SelectedAMLSCORE +
      this.state.SelectedCOMPLEXTypeSCORE +
      this.state.SelectedCINCORPTypeSCORE;
  }
  render() {
    //  let planets = this.state.AML;
    //  console.log("Finallu",planets)
    // let optionItems = planets.map((planet) =>
    //         <option >{planet.DESCRIPTION}</option>
    //     );
    return (
      <Fragment>
        <Navigationmenu selectedMenu={"CDDCRM"} />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ marginTop: 35 }}
        >
          <Paper
            elevation={2}
            style={{ minHeight: 100, width: "90%", borderRadius: 6 }}
          >
            <form>
              <Box display="flex" alignItems="center" justifyContent="center">
                <div style={{ minHeight: 100, width: "98%", borderRadius: 6 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={11}>
                      <div
                        style={{
                          display: "flex",
                          marginBottom: 20,
                          marginTop: 60,
                        }}
                      >
                        <Typography
                          style={{
                            borderWidth: 0,
                            color: BLUE_COLOR,
                            textTransform: "uppercase",
                            fontFamily: "Globerbold",
                            fontSize: 30,
                            paddingLeft: 10,
                          }}
                        >
                          Client Risk Profile
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                  {/*FILTER DROPDOWNS*/}
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={1}
                      style={{
                        fontSize: "18px",
                        fontFamily: "Globerbold",
                        color: BLUE_COLOR,
                      }}
                    >
                      Company
                    </Grid>
                    <Grid item xs={3}>
                      <Select
                        fullWidth
                        variant={"outlined"}
                        value={this.state.SelectedCompany}
                        onChange={(e) =>
                          this.setState(
                            { SelectedCompany: e.target.value },
                            this.FntoSetProductypes(e.target.value)
                          )
                        }
                      >
                        {this.state.CompanyType.map((team) => (
                          <MenuItem value={team.COMPANY}>
                            {team.COMPANY}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        label="Client No"
                        value={this.state.SelectedClientName}
                        onChange={(e) =>
                          this.handeltextChange(e, "SelectedClientName")
                        }
                        variant="outlined"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      style={{
                        fontSize: "18px",
                        fontFamily: "Globerbold",
                        color: BLUE_COLOR,
                      }}
                    >
                      ClientType
                    </Grid>
                    <Grid item xs>
                      <Select
                        fullWidth
                        InputProps={{ readOnly: true }}
                        variant={"outlined"}
                        value={this.state.SelectedClientType}
                        onChange={(e) =>
                          this.setState(
                            { SelectedClientType: e.target.value },
                            this.fnsetclientType(e.target.value)
                          )
                        }
                      >
                        {this.state.ClientType.map((team) => (
                          <MenuItem value={team.CLIENTTYPE}>
                            {team.CLIENTTYPE}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={1}>
                      <Select
                        fullWidth
                        variant={"outlined"}
                        value={this.state.SelectedNICType}
                        onChange={(e) =>
                          this.setState(
                            {
                              SelectedNICType: e.target.value,
                              SelectedNicLabel: e.target.value,
                            },
                            this.FntocheckpassDrop(e.target.value)
                          )
                        }
                      >
                        {this.state.NICdrop.map((team) => (
                          <MenuItem value={team.GRP_VALUES}>
                            {team.GRP_VALUES}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        label={this.state.SelectedNicLabel}
                        value={this.state.SelectedNic}
                        variant="outlined"
                        onChange={(e) =>
                          this.handeltextChange(e, "SelectedNic")
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      style={{
                        fontSize: "18px",
                        fontFamily: "Globerbold",
                        color: BLUE_COLOR,
                        display: this.state.displaycountry,
                      }}
                    >
                      Country
                    </Grid>
                    <Grid
                      item
                      xs={3}
                      style={{ display: this.state.displaycountry }}
                    >
                      <Select
                        fullWidth
                        variant={"outlined"}
                        value={this.state.selectedDropCountry}
                        onChange={(e) =>
                          this.setState({ selectedDropCountry: e.target.value })
                        }
                      >
                        {this.state.Dropcountry.map((team) => (
                          <MenuItem value={team.CODE}>
                            {team.DESCRIPTION}
                          </MenuItem>
                        ))}
                      </Select>{" "}
                    </Grid>

                    <Grid item xs>
                    </Grid>
                    <Button
                      variant={"text"}
                      disabled={this.state.SearchButtonDisable}
                      onClick={(e) =>
                        this.RefinitiveresponseandCRP("SEARCHCRP")
                      }
                      style={{
                        color: "white",
                        fontFamily: "Globerbold",
                        backgroundColor: this.state.searchbuttonbackcolor,
                        width: "7%",
                        fontSize: 18,
                        height: "53px",
                        marginTop: "9px",
                        marginRight: "15px",
                      }}
                    >
                      Search
                    </Button>
                    <Button
                      variant={"text"}
                      onClick={(e) => this.clearScreen()}
                      style={{
                        color: "white",
                        fontFamily: "Globerbold",
                        backgroundColor: this.state.clearbuttonbackcolor,
                        width: "7%",
                        fontSize: 18,
                        height: "53px",
                        marginTop: "9px",
                        marginRight: "7px",
                      }}
                    >
                      Clear
                    </Button>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={1}
                      style={{
                        fontSize: "18px",
                        fontFamily: "Globerbold",
                        color: BLUE_COLOR,
                      }}
                    >
                      Client Name
                    </Grid>
                    <Grid item xs={7}>
                      <TextField
                        fullWidth
                        variant={"outlined"}
                        InputProps={{ readOnly: true }}
                        value={this.state.ClientNameValue}
                      ></TextField>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      <TextField
                        fullWidth
                        label="Date"
                        InputProps={{ readOnly: true }}
                        value={this.state.selectedDate}
                        variant="filled"
                      />
                    </Grid>
                    <Grid item xs>
                      <TextField
                        fullWidth
                        label="Risk Profile"
                        value={this.state.riskProfile}
                        variant="filled"
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                    <Grid item xs>
                      Is Admin
                      <Switch
                        disabled={this.state.isadminSwitch}
                        checked={this.state.isadmin}
                        onChange={(e) => this.handleChange(e)}
                        color="primary"
                        name="checkedB"
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                    </Grid>
                  </Grid>
                  <Divider style={{ marginTop: 15 }} />
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      {/* <EditableLabel
                            initialValue={'Client Owner Type :'}
                            save={value => {
                                console.log(`Saving '${value}'`);
                            }}
                        /> */}
                      Client Owner Type :
                    </Grid>
                    <Grid item xs>
                      <TextField
                        fullWidth
                        variant={"outlined"}
                        value={this.state.SelectedOwnerType}
                        InputProps={{ readOnly: true }}
                        onChange={(e) =>
                          this.setState({
                            SelectedOwnerType: e.target.value,
                            SelectedOwnerTypeSCORE: Number(
                              e.currentTarget.getAttribute("data-score")
                            ),
                          })
                        }
                      >
                        {/* {this.state.OWNERTYPE.map((team) => (
                          <MenuItem value={team.CODE} data-score={team.SCORE}>
                            {team.DESCRIPTION}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs>
                      <h3 style={{ display: this.state.isadmin ? "" : "none" }}>
                        {" "}
                        {this.state.SelectedOwnerTypeSCORE}
                      </h3>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      Country of Incorporation/Nationality of Client :
                    </Grid>
                    <Grid item xs>
                      <TextField
                        fullWidth
                        variant={"outlined"}
                        value={this.state.SelectedNATIONALITYType}
                        InputProps={{ readOnly: true }}
                        onChange={(e) =>
                          this.setState({
                            SelectedNATIONALITYType: e.target.value,
                            SelectedNATIONALITYTypeSCORE: Number(
                              e.currentTarget.getAttribute("data-score")
                            ),
                          })
                        }
                      >
                        {/* {this.state.NATIONALITY.map((team) => (
                          <MenuItem value={team.CODE} data-score={team.SCORE}>
                            {team.DESCRIPTION}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs>
                      <h3 style={{ display: this.state.isadmin ? "" : "none" }}>
                        {" "}
                        {this.state.SelectedNATIONALITYTypeSCORE}
                      </h3>
                    </Grid>
                  </Grid>{" "}
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      Residential Location/ Registered Address of Client :
                    </Grid>
                    <Grid item xs>
                      <TextField
                        fullWidth
                        variant={"outlined"}
                        InputProps={{ readOnly: true }}
                        value={this.state.SelectedCOUNTRYYType}
                        onChange={(e) =>
                          this.setState({
                            SelectedCOUNTRYYType: e.target.value,
                            SelectedCOUNTRYTypeSCORE: Number(
                              e.currentTarget.getAttribute("data-score")
                            ),
                          })
                        }
                      >
                        {/* {this.state.COUNTRY.map((team) => (
                          <MenuItem value={team.CODE} data-score={team.SCORE}>
                            {team.DESCRIPTION}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs>
                      <h3 style={{ display: this.state.isadmin ? "" : "none" }}>
                        {" "}
                        {this.state.SelectedCOUNTRYTypeSCORE}
                      </h3>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      What is the target sector of the client/company?
                    </Grid>
                    <Grid item xs>
                      <TextField
                        fullWidth
                        variant={"outlined"}
                        InputProps={{ readOnly: true }}
                        value={this.state.SelectedTSECTORType}
                        onChange={(e) =>
                          this.FnforotherOccupation("BENEFSLL", e)
                        }
                      >
                        {/* {this.state.TSECTOR.map((team) => (
                          <MenuItem value={team.CODE} data-score={team.SCORE}>
                            {team.DESCRIPTION}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs>
                      <h3 style={{ display: this.state.isadmin ? "" : "none" }}>
                        {" "}
                        {this.state.SelectedTSECTORTypeSCORE}
                      </h3>
                    </Grid>
                  </Grid>
                  {this.state.ShowOccupation ? (
                    <Grid container spacing={2} style={{ marginTop: 10 }}>
                      <Grid item xs>
                        Others Occupation (please specify)
                      </Grid>
                      <Grid item xs>
                        <Typography
                          style={{
                            fontFamily: "Globerbold",
                            color: MODIFIEDBLACK,
                            fontSize: 16,
                          }}
                        >
                          <FormControl fullWidth>
                            <TextField
                              label=""
                              style={{ width: "100%" }}
                              value={this.state.SelectedTSECTORText}
                              onChange={(e) =>
                                this.handeltextChange(e, "SelectedTSECTORText")
                              }
                              InputProps={{
                                style: {
                                  fontFamily: "Globerbold",
                                  color: MODIFIEDBLACK,
                                },
                                readOnly: true,
                              }}
                              variant="outlined"
                            />
                          </FormControl>
                        </Typography>
                      </Grid>
                      <Grid item xs>
                        {/* <h3 style={{display:this.state.isadmin? "":"none"}}> {this.state.SelectedTSECTORTypeSCORE}</h3> */}
                      </Grid>
                    </Grid>
                  ) : null}
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      Is the client a PEP or linked to a PEP?
                    </Grid>
                    <Grid item xs>
                      <TextField
                        fullWidth
                        variant={"outlined"}
                        InputProps={{ readOnly: true }}
                        value={this.state.SelectedPEPType}
                        onChange={(e) =>
                          this.setState({
                            SelectedPEPType: e.target.value,
                            SelectedPEPTypeSCORE: Number(
                              e.currentTarget.getAttribute("data-score")
                            ),
                          })
                        }
                      >
                        {/* {this.state.PEP.map((team) => (
                          <MenuItem value={team.CODE} data-score={team.SCORE}>
                            {team.DESCRIPTION}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs>
                      <h3 style={{ display: this.state.isadmin ? "" : "none" }}>
                        {" "}
                        {this.state.SelectedPEPTypeSCORE}
                      </h3>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      Is the applicant listed on AML watchlist?
                    </Grid>
                    <Grid item xs>
                      <TextField
                        fullWidth
                        variant={"outlined"}
                        InputProps={{ readOnly: true }}
                        value={this.state.SelectedAMl}
                        onChange={(e) =>
                          this.setState({
                            SelectedAMl: e.target.value,
                            SelectedAMLSCORE: Number(
                              e.currentTarget.getAttribute("data-score")
                            ),
                          })
                        }
                      >
                        {/* {this.state.AML.map((team) => (
                          <MenuItem value={team.CODE} data-score={team.SCORE}>
                            {team.DESCRIPTION}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs>
                      <h3 style={{ display: this.state.isadmin ? "" : "none" }}>
                        {" "}
                        {this.state.SelectedAMLSCORE}
                      </h3>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs>
                      Is it a complex structure?
                    </Grid>
                    <Grid item xs>
                      <TextField
                        fullWidth
                        variant={"outlined"}
                        InputProps={{ readOnly: true }}
                        value={this.state.SelectedCOMPLEXType}
                        onChange={(e) =>
                          this.setState({
                            SelectedCOMPLEXType: e.target.value,
                            SelectedCOMPLEXTypeSCORE: Number(
                              e.currentTarget.getAttribute("data-score")
                            ),
                          })
                        }
                      >
                        {/* {this.state.COMPLEX.map((team) => (
                          <MenuItem value={team.CODE} data-score={team.SCORE}>
                            {team.DESCRIPTION}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs>
                      <h3 style={{ display: this.state.isadmin ? "" : "none" }}>
                        {" "}
                        {this.state.SelectedCOMPLEXTypeSCORE}
                      </h3>
                    </Grid>
                  </Grid>
                  {/*              
            <Grid container  spacing={2} style={{marginTop:10}}>
              <Grid item xs>
              Country of incorporation of the company :
              </Grid>
              <Grid item xs >
              <Select fullWidth 
                        variant={'outlined'}
                        value={this.state.SelectedCINCORPType}
                        onChange={e=>this.setState({SelectedCINCORPType:e.target.value,
                        SelectedCINCORPTypeSCORE:Number(e.currentTarget.getAttribute('data-score')) 
                      })}
                      >
                  {this.state.CINCORP.map(team => (
               <MenuItem value={team.CODE} data-score= {team.SCORE}>{team.DESCRIPTION}</MenuItem>
                  ))}
                 </Select>
              </Grid>
              <Grid item xs> 
              <h3 style={{display:this.state.isadmin? "":"none"}}> {this.state.SelectedCINCORPTypeSCORE}</h3>
              </Grid>
            </Grid> 
             */}
                  {this.state.showBeneficiaryComponent ? (
                    <Grid container spacing={2} style={{ marginTop: 10 }}>
                      <Grid item xs>
                        {this.state.selectedbeneficiaryLabel}
                      </Grid>
                      <Grid item xs>
                        <Select
                          fullWidth
                          disabled={this.state.disableBenef}
                          variant={"outlined"}
                          value={this.state.SelectedBENEFType}
                          onChange={(e) =>
                            this.setState({
                              SelectedBENEFType: e.target.value,
                              SelectedBENEFTypeSCORE: Number(
                                e.currentTarget.getAttribute("data-score")
                              ),
                            })
                          }
                        >
                          {this.state.BENEF.map((team) => (
                            <MenuItem value={team.CODE} data-score={team.SCORE}>
                              {team.DESCRIPTION}
                            </MenuItem>
                          ))}
                          {this.state.NANBenef ? (
                            ""
                          ) : (
                            <MenuItem value="NA" data-score={0}>
                              Not Applicable
                            </MenuItem>
                          )}
                        </Select>
                      </Grid>
                      <Grid item xs>
                        <h3
                          style={{ display: this.state.isadmin ? "" : "none" }}
                        >
                          {" "}
                          {this.state.SelectedBENEFTypeSCORE}
                        </h3>
                      </Grid>
                    </Grid>
                  ) : null}
                  <Divider style={{ marginTop: 15 }} />
                  <Grid container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item xs></Grid>
                    <Grid item xs></Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 20 }}></Grid>
                </div>
                <Dialog
                  open={this.state.showalertPopup}
                  onClose={(e) => this.setState({ showalertPopup: false })}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle
                    id="alert-dialog-title"
                    style={{
                      fontSize: "20px",
                      fontFamily: "Globerbold",
                      color: BLUE_COLOR,
                    }}
                  >
                    {"Please Confirm!"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText
                      id="alert-dialog-description"
                      style={{ fontFamily: "Globerbold" }}
                    >
                      Kindly ensure that all questions have been correctly
                      answered before saving data.“Do you want to go back to
                      edit your answers on the RBA?”
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      variant={"text"}
                      onClick={(e) => this.handlesetalert("YES")}
                      style={{
                        color: "white",
                        fontFamily: "Globerbold",
                        backgroundColor: VIBRANT_GREEN,
                        width: "30%",
                        fontSize: 18,
                      }}
                    >
                      YES
                    </Button>
                    <Button
                      variant={"text"}
                      onClick={(e) => this.handlesetalert("NO")}
                      style={{
                        color: "white",
                        marginLeft: "10px",
                        fontFamily: "Globerbold",
                        backgroundColor: RED_COLOR,
                        width: "30%",
                        fontSize: 18,
                      }}
                    >
                      NO
                    </Button>
                  </DialogActions>
                </Dialog>
              </Box>
            </form>
          </Paper>
        </Box>
      </Fragment>
    );
  }
}
